export default {
  start: '',
  end: '',
  numberOfNightsMin: 6,
  numberOfNightsMax: 14,
};
